import React, { useState, useContext } from "react";
import styled from "styled-components";
import Modal from "common/Modal";
import NumberInput from "common/NumberInputWithSpinnerState";

const Warning = styled.div`
  margin-top: 10px;
`;

const ThresholdModal = ({
  setDisplayModal,
  metric,
  unit,
  label,
  labelForModal,
  threshold,
  updateThresholds
}) => {
  const [thresholdValue, setThresholdValue]=useState(threshold);
  const doApply = () => {
    updateThresholds(metric, thresholdValue);
    setDisplayModal(false);
  };
  const doClose = () => setDisplayModal(false);

  return (
    <Modal
      title="Thresholds Settings"
      content={() => (
          <div>
            <NumberInput
              initialValue={threshold}
              name={metric}
              label={`${labelForModal ?? label}${unit ? ` ${unit}` : ""}`}
              onChange={(value)=>setThresholdValue(value)}
            />
            <Warning>Warning when above this value.</Warning>
          </div>
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={thresholdValue === threshold}
      closeLabel="CANCEL"
      onClose={doClose}
    />
  );
};

export default ThresholdModal;
